// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Accessible Off-Canvas Nav for Ghost
// This script manages open/close, focus trap, ARIA state, and keyboard support.

document.addEventListener('DOMContentLoaded', function () {
  const burger = document.getElementById('nav-burger');    // Burger button
  const menu = document.getElementById('main-menu');      // Off-canvas nav
  const closeBtn = document.getElementById('nav-close');    // Close button (X)
  const overlay = document.getElementById('nav-overlay');   // Overlay behind nav

  // Save last focused element to restore on close
  let lastFocus = null;

  // Utility: Trap focus inside menu (very basic)
  function trapFocus(e) {
    const focusable = menu.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      }
      if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }

  // Open mobile menu
  function openMenu() {
    menu.hidden = false;
    menu.setAttribute('data-open', 'true');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    overlay.hidden = false;
    overlay.setAttribute('data-open', 'true');
    lastFocus = document.activeElement;
    menu.focus(); // Moves focus for screen readers

    // Listen for focus trap & ESC key
    document.addEventListener('keydown', onKeyDown);
  }

  // Close mobile menu
  function closeMenu() {
    menu.setAttribute('data-open', 'false');
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    overlay.setAttribute('data-open', 'false');
    // Wait for transition before hiding
    setTimeout(() => { menu.hidden = true; overlay.hidden = true; }, 200);
    // Restore focus
    if (lastFocus) lastFocus.focus();
    document.removeEventListener('keydown', onKeyDown);
  }

  // Keydown handler for ESC/focus trap
  function onKeyDown(e) {
    if (e.key === 'Escape') closeMenu();
    else trapFocus(e);
  }

  // --- Event Listeners ---
  burger.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  // Close menu on resize to desktop
  window.addEventListener('resize', () => {
    if (window.innerWidth > 800 && menu.getAttribute('data-open') === 'true') {
      closeMenu();
    }
  });

  // Accessibility: Ensure ARIA states on load
  menu.setAttribute('aria-hidden', 'true');
  burger.setAttribute('aria-expanded', 'false');
  menu.hidden = true;
  overlay.hidden = true;
});
